import { API_POST_WABAID } from '../api/chat.service';

export function formatMessage(message, sentBy, urlChange = false) {
  let chat = {};
  if (sentBy == 'outbound' && message?.message) {
    let __message = null;
    let messageType = null;
    try {
      __message =
        message?.message && typeof message?.message === 'string'
          ? JSON.parse(message.message)
          : message.message;

      messageType = __message?.type;
      chat['messageType'] = messageType;
    } catch (error) {
      console.log(error);
      return;
    }

    // If context exists, add it to the chat object
    if (__message?.context) {
      chat['context'] = __message.context;
    }

    switch (messageType) {
      case 'list':
        chat['text'] = __message.title != undefined ? __message?.title + ', ' : '';
        chat['text'] += __message?.body;
        chat['button'] = [...__message?.globalButtons];
        break;
      case 'product_details':
        chat['text'] = __message?.body?.text;
        chat['button'] = [
          {
            text: 'View Items',
            title: 'View Items',
          },
        ];
        break;
      case 'quick_reply':
        chat['messageType'] = 'list';
        chat['text'] = __message?.content?.text;
        if (__message.type == 'image' || __message.type == 'file' || __message.type == 'video') {
          chat['url'] = __message?.content?.url;
        }
        chat['button'] = [...__message?.options];
        break;
      case 'text':
        chat['text'] = __message?.text;
        break;
      case 'address_message':
        chat['text'] = __message.body?.text;
        break;

      case 'link':
        chat['text'] = 'Campaign List';
        chat['link'] = __message?.campaignLink;
        break;
      case 'image':
        chat['text'] = __message?.caption;
        chat['url'] = __message?.originalUrl;
        break;
      case 'file':
        chat['text'] = __message?.caption;
        chat['filename'] = __message?.filename;
        chat['size'] = __message?.size;
        chat['url'] = __message?.url;
        break;
      case 'audio':
        chat['text'] = ' ';
        chat['url'] = __message?.url;
        break;
      case 'video':
        chat['text'] = __message?.caption;
        chat['url'] = __message?.url;
        break;
      case 'sticker':
        chat['text'] = '';
        chat['url'] = message?.url;
        break;
      case 'contact':
        chat['payload'] = message?.payload?.payload;
        break;
      case 'location':
        // chat["text"] = "Location shared";
        chat['latitude'] = message?.payload?.payload?.latitude;
        chat['longitude'] = message?.payload?.payload?.longitude;
      default:
        chat['text'] = '';
    }
  } else {
    const { payload } = message;

    const payloadType = payload.type;
    chat['messageType'] = payloadType;

    // If context exists in the payload, add it to the chat object
    if (payload?.context) {
      chat['context'] = payload?.context;
    }

    switch (payloadType) {
      case 'list_reply':
        chat['text'] = payload?.payload?.title;
        break;
      case 'button_reply':
        chat['text'] = payload?.payload?.title;
        break;
      case 'quick_reply':
        chat['text'] = payload?.payload?.text;
        break;

      case 'order':
        const items = payload?.context?.catalog?.order?.items;
        chat['orderItems'] = items;
        chat['text'] = `Order Details`;
        break;
      case 'text':
        chat['text'] = payload?.payload?.text;
        break;
      case 'nfm_reply':
        const address = payload?.payload?.addressDetails;
        chat['text'] =
          'Pin Code : ' +
          address?.in_pin_code +
          ', Address : ' +
          address?.address +
          ', ' +
          address?.landmark_area +
          ', ' +
          address?.city +
          ', Mob.No : ' +
          address?.phone_number;
        break;

      case 'reaction':
        chat['text'] = payload?.payload?.emoji;
        break;
      case 'image':
        chat['text'] = payload?.payload?.caption ? payload?.payload?.caption : ' ';
        chat['url'] = payload?.payload?.skalebotUrl
          ? payload?.payload?.skalebotUrl
          : payload?.payload?.url;
        // var response = null;
        // if(!payload?.payload?.skalebotUrl&&urlChange){
        //     const config={
        //       "customerMobile":payload?.sender?.phone,
        //       "gsId" :payload?.id,
        //     }
        //     response=  API_POST_WABAID(config).then((res)=>{
        //       chat["url"]=res.skalebotUrl;
        //     });
        // }
        chat['contentType'] = payload?.payload?.contentType;
        break;
      case 'file':
        chat['text'] = payload.payload?.caption ? payload.payload?.caption : ' ';
        chat['filename'] = payload?.payload?.name;
        chat['url'] = payload?.payload?.skalebotUrl
          ? payload?.payload?.skalebotUrl
          : payload?.payload?.url;
        // var response = null;
        // if(!payload?.payload?.skalebotUrl&&urlChange){
        //     const config={
        //       "customerMobile":payload?.sender?.phone,
        //       "gsId" :payload?.id,
        //     }
        //     response=  API_POST_WABAID(config).then((res)=>{
        //       chat["url"]=res.skalebotUrl;
        //     });
        // }
        chat['contentType'] = payload?.payload?.contentType;
        break;
      case 'audio':
        chat['text'] = ' ';
        chat['url'] = payload?.payload?.skalebotUrl
          ? payload?.payload?.skalebotUrl
          : payload?.payload?.url;
        // var response = null;
        // if(!payload?.payload?.skalebotUrl&&urlChange){
        //     const config={
        //       "customerMobile":payload?.sender?.phone,
        //       "gsId" :payload?.id,
        //     }
        //     response=  API_POST_WABAID(config).then((res)=>{
        //       chat["url"]=res.skalebotUrl;
        //     });
        // }
        break;
      case 'video':
        chat['text'] = payload?.payload?.caption ? payload.payload?.caption : ' ';
        chat['url'] = payload?.payload?.skalebotUrl
          ? payload?.payload?.skalebotUrl
          : payload?.payload?.url;
        // var response = null;
        // if(!payload?.payload?.skalebotUrl&&urlChange){
        //     const config={
        //       "customerMobile":payload?.sender?.phone,
        //       "gsId" :payload?.id,
        //     }
        //     response=  API_POST_WABAID(config).then((res)=>{
        //       chat["url"]=res.skalebotUrl;
        //     });
        // }
        chat['contentType'] = payload?.payload?.contentType;
        break;
      case 'sticker':
        chat['text'] = '';
        chat['url'] = payload?.payload?.url;
        var response = null;
        chat['contentType'] = payload?.payload?.contentType;
        break;
      case 'contact':
        chat['payload'] = message?.payload?.payload;
        break;
      case 'location':
        // chat["text"] = "Location shared";
        chat['latitude'] = message?.payload?.payload?.latitude;
        chat['longitude'] = message?.payload?.payload?.longitude;
        break;
      default:
        chat['text'] = '';
    }
  }

  return chat;
}

export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

export function StatusIcon(message) {
  if (message.status === 'read') {
    return (
      <img
        width="14"
        height="14"
        className="mt-2"
        src="https://img.icons8.com/ios-filled/50/34B7F1/double-tick.png"
        alt="double-tick"
      />
    );
  } else if (message.status === 'delivered') {
    return (
      <img
        width="14"
        height="14"
        className="mt-2"
        src="https://img.icons8.com/ios-filled/50/A3ABA5/double-tick.png"
        alt="double-tick"
      />
    );
  } else if (message.status === 'sent') {
    return (
      <img
        width="14"
        className="mt-1"
        height="14"
        src="https://img.icons8.com/material/24/A3ABA5/checkmark--v1.png"
        alt="checkmark--v1"
      />
    );
  } else if (message.status === 'failed') {
    return (
      <img
        width="14"
        height="14"
        src="https://img.icons8.com/color/48/high-importance--v1.png"
        alt="checkmark--v1"
      />
    );
  } else {
    return <></>;
  }
}

export function ticketStausSorted(dataArr) {
  let statusBasedTickets = {
    'In Progress': [],
    New: [],
    'Follow Up': [],
    Closed: [],
    noStatus: [],
  };
  dataArr.forEach((element) => {
    if (element.ticketStatus) {
      let currentElemts = statusBasedTickets[`${element?.ticketStatus}`];

      statusBasedTickets[`${element?.ticketStatus}`] = [...currentElemts, element];
    } else {
      let noStatusElements = statusBasedTickets.noStatus;
      statusBasedTickets.noStatus = [...noStatusElements, element];
    }
  });

  return [
    ...statusBasedTickets['In Progress'],
    ...statusBasedTickets['New'],
    ...statusBasedTickets['Follow Up'],
    ...statusBasedTickets['Closed'],
    ...statusBasedTickets['noStatus'],
  ];
}

export function isTimeOver(lastTimeStamp, limitTimeStamps) {
  let currentTimerStamps = new Date().getTime();
  let timeAgo = currentTimerStamps - limitTimeStamps;
  if (lastTimeStamp) {
    return lastTimeStamp < timeAgo;
  }
  return true;
}
export function isTimeOverWCA(lastTimeStamp, limitTimeStamps) {
  if (!lastTimeStamp) return true;

  const now = Date.now();

  // Auto-detect: if timestamp is in seconds, convert to ms
  const normalizedLastTime = lastTimeStamp < 1e12 ? lastTimeStamp * 1000 : lastTimeStamp;

  return now - normalizedLastTime > limitTimeStamps;
}

export const formatWcaMessage = (raw) => {
  const msgId = raw.msgId || raw.gsId || raw.id || raw._id || raw.msg_id;

  let msgObj = raw.message;
  if (!msgObj) {
    msgObj = {};
  } else if (typeof msgObj === 'string') {
    try {
      msgObj = JSON.parse(msgObj);
    } catch {
      // If it's a plain string, treat it as simple text
      msgObj = { text: { body: msgObj }, type: 'text' };
    }
  }

  // Some responses include WA shape directly under `message` (with .text, .type, .timestamp)
  const messageType = raw.type || msgObj?.type;

  // formatted text for display: keep original structured object in rawMessage
  const formatted = (() => {
    // --- CALL EVENTS ---
    if (raw?.type === 'inbound-call' || raw?.type === 'outbound-call') {
      const isInboundCall = raw?.type === 'inbound-call';
      const callStatus = msgObj?.status || 'UNKNOWN';
      const duration = Number(msgObj?.duration || 0);
      const hasFailed = callStatus === 'FAILED' || Array.isArray(msgObj?.errors) && msgObj.errors.length > 0;

      let title = isInboundCall ? 'Incoming voice call' : 'Outgoing voice call';
      if (callStatus === 'COMPLETED') {
        title = isInboundCall ? 'Incoming call' : 'Outgoing call';
      } else if (hasFailed) {
        title = isInboundCall ? 'Missed incoming call' : 'Outgoing call failed';
      }

      let subtitle = '';
      if (hasFailed) {
        subtitle = 'Call was not connected';
      } else if (duration > 0) {
        subtitle = `Duration: ${duration}s`;
      } else if (callStatus && callStatus !== 'COMPLETED') {
        subtitle = `Status: ${callStatus}`;
      }

      return {
        call: true,
        text: title,
        subtitle,
        callStatus,
        callDirection: msgObj?.direction || (isInboundCall ? 'USER_INITIATED' : 'BUSINESS_INITIATED'),
        duration,
        errors: msgObj?.errors || [],
        messageType: 'call',
      };
    }

    // --- CALL PERMISSION REPLY ---
    if (
      msgObj?.type === 'interactive' &&
      msgObj?.interactive?.type === 'call_permission_reply'
    ) {
      return {
        hidden: true,
        messageType: 'call_permission_reply',
      };
    }

    // --- TEXT ---
    if (msgObj?.text?.body) return { text: msgObj.text.body, messageType: msgObj.type || 'text' };
    if (msgObj?.text) {
      // sometimes text is a string
      return {
        text: typeof msgObj.text === 'string' ? msgObj.text : msgObj.text?.content || '',
        messageType: msgObj.type || 'text',
      };
    }

    // --- IMAGE ---
    if (msgObj?.type === 'image' || msgObj?.image) {
      const url = msgObj?.image?.url || msgObj?.url || msgObj?.image?.src || msgObj?.url;
      const text = msgObj?.image?.caption;
      return { image: true, url, messageType: 'image', text };
    }
    // --- VIDEO ---
    if (msgObj?.type === 'video' || msgObj?.video) {
      const url = msgObj?.video?.url || msgObj?.url;
      const text = msgObj?.video?.caption;
      return { video: true, url, messageType: 'video', text };
    }
    // --- AUDIO ---
    if (msgObj?.type === 'audio' || msgObj?.audio) {
      const url = msgObj?.audio?.url || msgObj?.url;
      const text = msgObj?.audio?.caption;
      return { audio: true, url, messageType: 'audio', text };
    }
    // --- FILE ---
    if (
      msgObj?.type === 'file' ||
      msgObj?.type === 'document' ||
      msgObj?.document ||
      msgObj?.file
    ) {
      const url = msgObj?.document?.url || msgObj?.url || msgObj?.file?.url;
      const filename = msgObj?.document?.filename || msgObj?.filename || msgObj?.file?.filename;
      const text = msgObj?.document?.caption;

      return { file: true, url, filename, messageType: 'file', text };
    }
    // --- Location ---
    if (msgObj?.type === 'location' || msgObj?.location) {
      const loc = msgObj?.location || msgObj;
      return {
        location: true,
        name: loc.name || '',
        address: loc.address || '',
        latitude: loc.latitude,
        longitude: loc.longitude,
        messageType: 'location',
      };
    }

    // --- Contacts ---
    if (msgObj?.type === 'contacts' || msgObj?.contacts) {
      const contacts = msgObj?.contacts || [];
      const formattedContacts = contacts.map((c) => ({
        name:
          c?.name?.formattedname || `${c?.name?.firstname || ''} ${c?.name?.lastname || ''}`.trim(),
        phones:
          c?.phones?.map((p) => ({
            type: p?.type,
            phone: p?.phone,
            waid: p?.waid,
          })) || [],
      }));
      return {
        contacts: true,
        contactList: formattedContacts,
        messageType: 'contacts',
      };
    }

    // --- Reaction ---
    if (msgObj?.type === 'reaction' || msgObj?.reaction) {
      const reaction = msgObj?.reaction || {};
      return {
        reaction: true,
        emoji: reaction.emoji || '',
        reactedToMessageId: reaction.message_id || reaction.messageId || reaction?.msg_id || null,
        messageType: 'reaction',
      };
    }

    // --- LIST ---
    if (msgObj?.type === 'list') {
      const title = msgObj?.title ? msgObj.title + ', ' : '';
      const body = msgObj?.body || '';
      return { text: title + body, buttons: msgObj?.globalButtons || [], messageType: 'list' };
    }

    // --- PRODUCT DETAILS ---
    if (msgObj?.type === 'product_details') {
      return {
        text: msgObj?.body?.text,
        buttons: [{ text: 'View Items', title: 'View Items' }],
        messageType: 'product_details',
      };
    }
    // --- QUICK REPLY ---
    if (msgObj?.type === 'quick_reply') {
      return {
        text: msgObj?.content?.text,
        buttons: msgObj?.options || [],
        url: msgObj?.content?.url,
        messageType: 'quick_reply',
      };
    }

    // --- ADDRESS MESSAGE ---
    if (msgObj?.type === 'address_message') {
      return { text: msgObj?.body?.text, messageType: 'address_message' };
    }

    // --- LINK ---
    if (msgObj?.type === 'link') {
      return { text: 'Campaign List', link: msgObj?.campaignLink, messageType: 'link' };
    }

    // --- STICKER ---
    if (msgObj?.type === 'sticker') {
      const url = msgObj?.url || msgObj?.sticker?.url;
      return { sticker: true, url, messageType: 'sticker' };
    }

    // --- ORDER ---
    if (msgObj?.type === 'order') {
      const items = msgObj?.context?.catalog?.order?.items || [];
      return { order: true, orderItems: items, text: 'Order Details', messageType: 'order' };
    }

    // --- NFM REPLY ---
    if (msgObj?.type === 'nfm_reply') {
      const address = msgObj?.payload?.addressDetails || {};
      const formattedText =
        `Pin Code: ${address?.in_pin_code}, ` +
        `Address: ${address?.address || ''}, ${address?.landmark_area || ''}, ${address?.city || ''
        }, ` +
        `Mob.No: ${address?.phone_number || ''}`;
      return { text: formattedText, messageType: 'nfm_reply' };
    }

    // --- TEMPLATE ---
    if (msgObj?.type === 'template' || msgObj?.template) {
      const template = msgObj.template || {};
      const components = template.components || [];

      let header = null;
      let bodyText = '';
      let media = null;
      const buttons = [];
      const variables = [];

      components.forEach((c) => {
        // ✅ HEADER
        if (c.type === 'header') {
          const param = c.parameters?.[0];

          if (param?.type === 'text') {
            header = param.text;
          }

          if (param?.type === 'image') {
            media = {
              type: 'image',
              url: param.image?.link,
            };
          }

          if (param?.type === 'video') {
            media = {
              type: 'video',
              url: param.video?.link,
            };
          }

          if (param?.type === 'document') {
            media = {
              type: 'document',
              url: param.document?.link,
            };
          }
        }

        // ✅ BODY
        if (c.type === 'body') {
          bodyText =
            c.parameters
              ?.map((p) => {
                if (p.parameter_name) {
                  variables.push({
                    key: p.parameter_name,
                    value: p.text,
                  });
                }
                return p.text;
              })
              .join(' ') || '';
        }

        // ✅ BUTTONS
        if (c.type === 'button') {
          const param = c.parameters?.[0];

          if (c.sub_type === 'quick_reply') {
            buttons.push({
              type: 'quick_reply',
              text: param?.text,
              index: c.index,
            });
          }

          if (c.sub_type === 'url') {
            buttons.push({
              type: 'url',
              text: param?.text,
              url: param?.url,
              index: c.index,
            });
          }
        }
      });

      return {
        text: bodyText || ` ${template.name}`,
        header,
        media, // 👈 NEW (image/video/document)
        buttons,
        variables, // 👈 NEW (important for preview/debug)
        templateName: template.name,
        language: template.language?.code,
        messageType: 'template',
      };
    }

    // fallback (unknown type)
    return {
      text: msgObj?.type ? `Message type: ${msgObj.type}` : 'Unsupported message type',
      messageType: msgObj?.type || 'unknown',
    };
  })();

  // determine a usable timestamp (many responses provide seconds epoch in `timestamp`)
  const finalTimestamp = (() => {
    if (raw.timestamp) {
      // API sometimes sends seconds; ensure numeric
      const ts = Number(raw.timestamp);
      return isNaN(ts) ? new Date(raw.timestamp) : new Date(ts * 1000);
    }
    if (msgObj?.timestamp) {
      const ts = Number(msgObj.timestamp);
      return isNaN(ts) ? new Date(msgObj.timestamp) : new Date(ts * 1000);
    }
    if (raw.createdAt) return new Date(raw.createdAt);
    return new Date();
  })();

  return {
    ...raw,
    msgId,
    rawMessage: msgObj,
    message: formatted,
    messageType, // inbound / outbound / other
    finalTimestamp,
  };
};

export const formatTelegramMessage = (raw) => {
  const msgId = raw.msgId || raw.message?.message_id || raw.message_id || raw.id || raw._id;

  let msgObj = raw.message || {};

  // normalize string payloads
  if (typeof msgObj === 'string') {
    try {
      msgObj = JSON.parse(msgObj);
    } catch {
      msgObj = { text: msgObj };
    }
  }

  // inbound / outbound (UI direction)
  const direction = raw.type;

  /* ----------------------------------
     FORMAT MESSAGE CONTENT
  -----------------------------------*/
  const formatted = (() => {
    // ---------- TEXT ----------
    if (msgObj?.text) {
      return {
        text: typeof msgObj.text === 'string' ? msgObj.text : '',
        messageType: 'text',
      };
    }

    // ---------- PHOTO ----------
    if (msgObj?.photo?.length) {
      const photo = msgObj.photo[msgObj.photo.length - 1];
      return {
        image: true,
        fileId: photo.file_id,
        filename: photo.file_id,
        caption: msgObj?.caption || '',
        messageType: 'image',
        url: msgObj?.mediaUrl,
      };
    }

    // ---------- VIDEO ----------
    if (msgObj?.video) {
      return {
        video: true,
        fileId: msgObj.video.file_id,
        filename: msgObj.video.file_name,
        caption: msgObj?.caption || '',
        duration: msgObj.video.duration,
        messageType: 'video',
        url: msgObj?.mediaUrl,
      };
    }

    // ---------- DOCUMENT ----------
    if (msgObj?.document) {
      return {
        file: true,
        fileId: msgObj.document.file_id,
        filename: msgObj.document.file_name,
        mimeType: msgObj.document.mime_type,
        caption: msgObj?.caption || '',
        messageType: 'file',
        url: msgObj?.mediaUrl,
      };
    }

    // ---------- AUDIO / VOICE ----------
    if (msgObj?.audio || msgObj?.voice) {
      const audio = msgObj.audio || msgObj.voice;
      return {
        audio: true,
        fileId: audio.file_id,
        filename: audio.file_id,
        duration: audio.duration,
        messageType: 'audio',
        url: msgObj?.mediaUrl,
      };
    }

    // ---------- STICKER ----------
    if (msgObj?.sticker) {
      return {
        sticker: true,
        fileId: msgObj.sticker.file_id,
        emoji: msgObj.sticker.emoji,
        messageType: 'sticker',
      };
    }

    // ---------- LOCATION ----------
    if (msgObj?.location) {
      return {
        location: true,
        latitude: msgObj.location.latitude,
        longitude: msgObj.location.longitude,
        messageType: 'location',
      };
    }

    // ---------- CONTACT ----------
    if (msgObj?.contact) {
      return {
        contact: true,
        name: `${msgObj.contact.first_name || ''} ${msgObj.contact.last_name || ''}`.trim(),
        phone: msgObj.contact.phone_number,
        messageType: 'contact',
      };
    }

    // ---------- FALLBACK ----------
    return {
      text: JSON.stringify(msgObj),
      messageType: 'text',
    };
  })();

  /* ----------------------------------
     TIMESTAMP NORMALIZATION
  -----------------------------------*/
  const finalTimestamp = (() => {
    if (raw.timestamp) return new Date(raw.timestamp * 1000);
    if (msgObj?.date) return new Date(msgObj.date * 1000);
    if (raw.createdAt) return new Date(raw.createdAt);
    return new Date();
  })();

  return {
    ...raw,
    msgId,
    rawMessage: msgObj,
    message: formatted, // UI friendly payload
    messageType: formatted.messageType, // text/image/video/file
    direction, // inbound-message / outbound-message
    finalTimestamp,
  };
};
